var map = {
	"./001.png": "cQBD",
	"./002.png": "HATP",
	"./003.png": "7pVL",
	"./004.png": "S03y",
	"./005.png": "92/I",
	"./006.png": "xmVf",
	"./007.png": "JsCI",
	"./008.png": "VeY9",
	"./009.png": "62Ry",
	"./010.png": "frcJ",
	"./011.png": "+XTt",
	"./012.png": "aCkd",
	"./013.png": "6ix/",
	"./014.png": "TtyF",
	"./015.png": "JVkH",
	"./050.png": "VkuL",
	"./051.png": "YzLy",
	"./052.png": "1c7z",
	"./053.png": "Ryld",
	"./054.png": "ZoD8",
	"./055.png": "pspC",
	"./056.png": "e1QQ",
	"./057.png": "S1hg",
	"./058.png": "SV7G",
	"./059.png": "EdG7",
	"./061.png": "SB59",
	"./071.png": "nBFt",
	"./072.png": "bAR8",
	"./073.png": "lMDa",
	"./074.png": "MaIE",
	"./075.png": "VInR",
	"./076.png": "cMmv",
	"./077.png": "dUHp",
	"./078.png": "6MBT",
	"./079.png": "+8N5",
	"./080.png": "iHlQ",
	"./081.png": "/nLp",
	"./082.png": "oIky",
	"./083.png": "gPXh",
	"./084.png": "3LPJ",
	"./085.png": "iITa"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7Ngx";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/yqs ^\.\/.*\.png$
// module id = 7Ngx
// module chunks = 0